<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>角色设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini" plain v-if="authorities.includes('system.role.new')"
               @click="showAddDialogVisible(1)" >新建角色</el-button>
      <!-- 添加角色的对话框 -->
      <el-dialog
        title="添加角色"
        :visible.sync="addDialogVisible"
        width="30%"
        style="position: absolute"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <span>
          角色名称：
          <el-input v-model="roleName" placeholder="请输入内容" size="mini" style="width: 300px;"></el-input>
        </span>
        <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancel">取 消</el-button>
        <el-button size="mini" @click="addRoleMethod">确 定</el-button>
        </span>
      </el-dialog>
    <el-card>
      <!-- 角色对应的权限 -->
      <el-table :data="roleList" border stripe :row-style="{height: '0'}" :header-cell-style="{background:'#eff3f8', color:'#333'}">
<!--        <el-table-column type="expand">-->
<!--          <template slot-scope="scope">-->
<!--            <el-row :class="['bdbottom', i1 === 1 ? 'bdtop' : '','vcenter']" v-for="(item1, i1) in scope.row.children" :key="item1.authorId">-->
<!--              &lt;!&ndash; 一级渲染 &ndash;&gt;-->
<!--              <el-col :span="5">-->
<!--                <el-tag closable @close="removeById(scope.row,item1.authorId)">{{item1.authorName}}</el-tag>-->
<!--                <i class="el-icon-caret-right"></i>-->
<!--              </el-col>-->
<!--              &lt;!&ndash; 二级、三级渲染 &ndash;&gt;-->
<!--              <el-col :span="19">-->
<!--                <el-row :class="[i2 === 2 ? '' : 'bdtop','vcenter']" v-for="(item2, i2) in item1.children" :key="item2.authorId">-->
<!--                  <el-col :span="6">-->
<!--                    <el-tag type="success" closable @close="removeById(scope.row,item2.authorId)">{{item2.authorName}}</el-tag>-->
<!--                    <i class="el-icon-caret-right"></i>-->
<!--                  </el-col>-->
<!--                  <el-col :span="18" >-->
<!--                    <el-row  v-for="(item3, i3) in item2.children" :key="item3.authorId">-->
<!--                      <el-tag type="warning" closable @close="removeById(scope.row,item3.authorId)">{{item3.authorName}}</el-tag>-->
<!--                    </el-row>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column type="index"></el-table-column>
        <el-table-column label="角色名称" prop="roleName"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" icon="el-icon-edit" v-if="authorities.includes('system.role.update')"
                       @click="showUpdateDialogVisible(scope.row,2)">编辑</el-button>
            <el-button size="mini" icon="el-icon-delete" v-if="authorities.includes('system.role.delete')"
                       @click="deleteRoleBox(scope.row)">删除</el-button>
            <el-button size="mini" icon="el-icon-setting"  v-if="authorities.includes('system.role.set')"
                       @click="showSetAuthorityDialog(scope.row)">分配权限</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      title="分配权限"
      :visible.sync="setAuthorityDialogVisible"
      width="50%" @close="setAuthorityDialogClose"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-tree show-checkbox :data="authorityList" :props="treeProps"
              node-key="id"
              default-expand-all :default-checked-keys="defKeys"
              ref="treeRef">
      </el-tree>
      <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="setAuthorityDialogVisible = false">取 消</el-button>
    <el-button size="mini" @click="allotAuthority">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      roleName: '',
      operatorType: '',
      authorities:'',
      addDialogVisible: false,
      roleList: [],
      authorityList: [],
      setAuthorityDialogVisible: false,
      treeProps: {
        label: 'authorName',
        children: 'children'
      },
      defKeys: [],
      roleId: '',
      userId: ''
    }

  },
  created() {
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.getRoleList();
  },
  methods: {
    showAddDialogVisible(type){
      this.addDialogVisible = true;
      this.operatorType = type;
    },
    cancel(){
      this.roleName = '';
      this.addDialogVisible = false;
    },
    showUpdateDialogVisible(role, type){
      this.addDialogVisible = true;
      this.roleName = role.roleName;
      this.roleId = role.id;
      this.operatorType = type;
    },
    async getRoleList(){
      const {data:res} = await this.$http.get('/roles');
      if (res.code !== 200){
        return this.$message.error("获取角色列表失败");
      }
      this.roleList = res.data;
    },
    //删除三级权限
    async removeById(role, authorId){
     const confirmResult = await this.$confirm('此操作将删除该权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)

      if (confirmResult !== 'confirm'){
        return this.$message.info("取消了删除！")
      }

      const {data:res} = await this.$http.delete(`roles/${role.id}/authorId/${authorId}`)
      if (res.code === 200){
        role.children = res.data;
        return this.$message.success("删除成功");
      } else {
        return this.$message.error("删除失败");
      }
    },
    async showSetAuthorityDialog(role){
      this.roleId = role.id;
      const {data:res} = await this.$http.get("auths/tree");
      if (res.code === 200){
        this.authorityList = res.data;
      }
      this.getLeafKeys(role,this.defKeys);
      this.setAuthorityDialogVisible = true;
    },
    getLeafKeys(node, arr){
      if(!node.children){
        return arr.push(node.authorId);
      }
      node.children.forEach(item => this.getLeafKeys(item,arr));
    },
    setAuthorityDialogClose(){
      this.defKeys = [];
    },
    async allotAuthority(){
      const keys = [
        ...this.$refs.treeRef.getCheckedKeys(),
        ...this.$refs.treeRef.getHalfCheckedKeys()
      ]
      const idKeys = keys.join(",")
      const {data:res} = await this.$http.post(`roles/${this.roleId}/authorIds/${idKeys}/userId/${this.userId}`)
      if (res.code !== 200){
        return this.$message.error("分配权限失败！")
      }

      this.$message.success("分配权限成功！")
      await this.getRoleList();
      this.setAuthorityDialogVisible = false;
    },
    async addRoleMethod(){
      //1.表示添加角色
      if (this.operatorType === 1){
        const {data:res} = await this.$http.post(`roleName/${this.roleName}/creator/${this.userId}`)

        if (res.code !== 200){
          return this.$message.error(res.msg);
        }
        this.$message.success(res.msg);
      }
      //2.表示更新角色
      if (this.operatorType === 2){
        const {data:res} = await this.$http.put(`roleName/${this.roleName}/modifier/${this.userId}/roleId/${this.roleId}`)

        if (res.code !== 200){
          return this.$message.error(res.msg);
        }
        this.$message.success(res.msg);
      }

      await this.getRoleList();
      this.roleName = '';
      this.addDialogVisible = false;
    },
    deleteRoleBox(data){
      this.roleId = data.id;
      this.$confirm('此操作将永久删除该角色, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteRole();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async deleteRole(){
      const {data:res} = await this.$http.delete(`roleId/${this.roleId}`)
      if (res.code !== 200){
        return this.$message.error(res.msg);
      }
      this.$message.success(res.msg);
      await this.getRoleList();
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.el-table{
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
  .el-tag{
    margin: 7px;
  }
  .bdtop {
    border-top: 1px solid #eee;
  }
  .bdbottom {
    border-top: 1px solid #eee;
  }
  .vcenter{
    display: flex;
    align-items: center;
  }
}
.el-input__inner{
  height: 30px;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Roles.vue